<template>
    <div id="settingDialogPc" class="live-dialog-bg" v-show="isShow">
        <div class="setting-container">
            <div class="setting-title">
                <span>更多设置</span>
                <van-icon name="cross" @click="onClose" />
            </div>
            <div class="setting-options" v-if="liveModal === 'interaction'">
                <span class="label">直播模式:</span>
                <van-radio-group v-model="activePage" @change="onLiveModeChange" direction="horizontal">
                    <van-radio checked-color="#07c160" name="live-pc">默认模式(仅观看直播)</van-radio>
                    <van-radio checked-color="#07c160" name="live-mutually-pc">互动模式</van-radio>
                </van-radio-group>
            </div>
            <div class="setting-options" v-if="lineList.lengt !== 0">
                <span class="label">直播线路:</span>
                <van-button
                    class="network-btn"
                    @click="onLineChange(item)"
                    v-for="item in lineList"
                    :key="item.val"
                    :type="activeLine === item.val ? 'primary' : 'default'"
                >
                    {{ item.name }}
                </van-button>
            </div>
            <div class="setting-options"  v-if="liveModal === 'desk'">
                <span class="label">网络模式:</span>
                <van-button
                    class="network-btn"
                    @click="onNetworkChange(item)"
                    v-for="item in networkModalList"
                    :key="item.val"
                    :type="activeNetwork === item.val ? 'primary' : 'default'"
                >
                    {{ item.name }}
                </van-button>
            </div>
            <div class="setting-options">
                <van-button color="#ef3131" @click="onLogout" class="logout-btn">退出登录</van-button>
            </div>
        </div>
    </div>
</template>
<script>
import { clearUserInfo } from '@/utils/login.js'

export default {
    props: ['isShow', 'networkLineList', 'liveCourse'],
    data() {
        return {
            liveModal: '',
            
            activePage: 'live-pc',
            activeLine: 0,
            networkModalList: [
                { name: '稳定模式', val: 'HLS', type: 'techOrder' },
                { name: '极速模式', val: 'FLV', type: 'techOrder' },
            ],
            activeNetwork: 'HLS',
        }
    },
    computed: {
        lineList: function () {
            const list = []
            this.networkLineList.forEach((item) => {
                list.push({ name: item.label, val: item.key, type: 'network' })
            })
            return list
        },
    },
    created() {
        if (this.liveCourse.mirageType === 0) {
            this.liveModal = 'desk'
        } else if (this.liveCourse.mirageType === 2) {
            this.liveModal = 'interaction'
        }

        const _page  = ['live-pc', 'live-mutually-pc']
        _page.forEach(p => {
            if (window.location.href.indexOf(`${p}.html`) > -1) {
                this.activePage = p
            }
        })
    },
    methods: {
        onClose() {
            this.$emit('onClose')
        },
        onLiveModeChange() {
            let url = window.location.href
            if (this.activePage === 'live-pc' && url.indexOf('live-pc') === -1) {
                url = url.replace('live-mutually-pc.html', 'live-pc.html')
                if (url.indexOf('&noMutually=1') === -1) {
                    url += '&noMutually=1'
                }
            } else if (this.activePage === 'live-mutually-pc' && url.indexOf('live-mutually-pc') === -1) {
                url = url.replace('live-pc.html', 'live-mutually-pc.html')
            }
            // 防止频繁刷新
            if (url !== window.location.href) {
                window.location.href = url
            }
        },
        // 线路切换
        onLineChange(item) {
            this.activeLine = item.val
            this.onSwitchNetwork(item)
        },
        // 网络模式切换
        onNetworkChange(item) {
            this.activeNetwork = item.val
            this.onSwitchNetwork(item)
        },
        onSwitchNetwork(item) {
            this.$emit('networkChange', item)
        },
        onLogout() {
            clearUserInfo()
            this.$toast({ message: '已退出登录', duration: 0 })
            setTimeout(() => {
                window.location.reload()
            }, 1000)
        },
    },
}
</script>

<style lang="scss">
#settingDialogPc {
    display: flex;
    align-items: center;
    justify-content: center;
    .setting-container {
        width: 480px;
        height: 320px;
        background: #fff;
        border-radius: 4px;
        position: relative;
    }
    .setting-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 28px;
        padding: 10px 20px;
        font-size: 18px;
        border-bottom: 1px solid #999;
        .van-icon {
            cursor: pointer;
            font-size: 24px;
        }
    }
    .setting-options {
        padding: 18px 24px 0;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .label {
            flex-shrink: 0;
            font-size: 14px;
            color: #666;
            margin-right: 16px;
        }
        .van-radio--horizontal {
            margin-bottom: 0;
        }
    }
    .network-btn {
        height: 32px;
        margin-right: 12px;
        &:last-child {
            margin-right: 0;
        }
    }
    .logout-btn {
        margin: 12px 72px;
        height: 36px;
        border-radius: 4px;
    }
}
</style>
